<template>
    <div class="wapper">
        <div class="query-wapper">
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-input placeholder="发票内容名称" v-model="query.name"></el-input>
                </el-col>
                <el-col :span="6">
                    <el-select placeholder="发票内容状态" v-model="query.state" style="width:100%;">
                        <el-option v-for="item in states" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="6">
                    <el-input placeholder="税收分类名称" v-model="query.categoryName"></el-input>
                </el-col>
                <el-col :span="6">
                    <el-input placeholder="税收分类编码" v-model="query.categoryCode"></el-input>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <Select :type="'InvoiceContentSourceEnum'" :placeholder="'请选择渠道来源'" @change="change" :selectData="selectData"></Select>
                </el-col>
            </el-row>
            <div class="button-wapper">
                <el-button plain @click="getInfoList(undefined)">查询</el-button>
                <el-button plain @click="reset">重置</el-button>
                <el-button plain @click="add" type="primary" v-auth="'edit'">新增</el-button>
                <el-button plain @click="invoiceDrawerClick" type="primary" v-auth="'viewSpecialFinance'">查看特殊发票内容</el-button>
            </div>
        </div>
        <div class="content-wapper">
            <el-table :data="infos" size='mini' empty-text :border="true">
                <el-table-column prop="id" label="发票内容ID"></el-table-column>
                <el-table-column prop="name" label="发票内容名称" width="200"></el-table-column>
                <el-table-column prop="taxRateString" label="发票税率" width="200"></el-table-column>
                <el-table-column prop="categoryName" label="税收分类名称" width="200"></el-table-column>
                <el-table-column prop="categoryCode" label="税收分类编码" width="200"></el-table-column>
                <el-table-column prop="sourceValue" label="渠道来源" width="200"></el-table-column>
                <el-table-column prop="remarks" label="备注"></el-table-column>
                <el-table-column prop="gmtCreate" label="创建时间"></el-table-column>
                <el-table-column prop="creatorName" label="创建人名称"></el-table-column>
                <el-table-column label="发票内容状态">
                    <template slot-scope="scope">
                        <el-switch v-auth="'edit'" v-model="scope.row.state" @change="updateInvoiceState(scope.row)"
                            :active-value="1" :inactive-value="2" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                        <span v-auth-reverse="'edit'">
                            {{ scope.row.stateValue }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="220">
                    <template slot-scope="scope">
                        <el-button @click="detail(scope.row)" type="text" size="small">查看</el-button>
                        <el-button v-auth="'edit'" @click="edit(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click="taxEven(scope.row)" type="text" size="small">关联税收分类</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <br>
            <el-pagination :current-page.sync="query.pageIndex" :page-size="query.pageSize"
                @current-change="handleCurrentChange" class="pagation" layout="prev, pager, next, jumper"
                :total="query.total">
            </el-pagination>
        </div>
        <!-- 添加合约公司 -->
        <addInvoiceContent ref="addInvoiceContent" @refresh="getInfoList"></addInvoiceContent>
        <taxDialog ref="taxDialogVisible"></taxDialog>
        <invoiceDrawer ref="invoiceDrawerVisible"></invoiceDrawer>
    </div>
</template>

<script>
import Select from '@/views/common/Select'
import _invoiceContent from '@/service/invoice-content-service'
import _constant from '@/utils/constant'
import addInvoiceContent from '@/views/invoice/content/add-invoice-content'
import invoiceDrawer from '@/views/invoice/content/invoice-drawer'
import taxDialog from '@/views/invoice/content/tax-dialog'
export default {
    components: {
        addInvoiceContent,
        Select,
        taxDialog,
        invoiceDrawer
    },
    data() {
        return {
            selectData:null,
            infos: null,
            states: null,
            query: {
                name: null,
                state: null,
                categoryName: null,
                categoryCode: null,
                source: null,
                pageIndex: 1,
                pageSize: 20,
                total: 0
            }
        }
    },
    mounted() {
        this.getInfoList()
        // 状态
        this.states = _constant.states
    },
    methods: {
        invoiceDrawerClick() {
           
            this.$refs.invoiceDrawerVisible.show()
        },
        detail(row) {
            this.$router.push({
                path: '/invoice-content-detail',
                query: {
                    id: row.id
                }
            })
        },
        taxEven(row) {
            this.$refs.taxDialogVisible.show(row.id, row.name)
        },
        //下拉选择
        change(val, label, type) {
            this.selectData = val
            if (type == 'InvoiceContentSourceEnum') {
                this.query.source = val
            }
        },
        getInfoList(pageIndex) {
            if (pageIndex)
                this.query.pageIndex = pageIndex
            else
                this.query.pageIndex = 1
            _invoiceContent.getInvoiceList(
                this.query,
                (response, total) => {
                    // 请求成功
                    this.infos = response
                    this.query.total = total
                })
        },
        handleCurrentChange(pageIndex) {
            this.getInfoList(pageIndex)
        },
        add() {
            this.$refs.addInvoiceContent.show()
        },
        edit(row) {
            this.$refs.addInvoiceContent.show(row.id)
        },
        reset() {
            this.query = {
                name: null,
                state: null,
                categoryName: null,
                categoryCode: null,
                source: null,
                pageIndex: 1,
                pageSize: 20,
                total: 0
            }
            this.selectData = null;
            this.getInfoList()
        },
        updateInvoiceState(rows) {

            this.$confirm(`是否确认要${rows.state == 1 ? '开启' : '关闭'}该发票状态，${rows.state == 1 ? '开启后' : '关闭后'}销售将${rows.state == 1 ? '可再次开具该发票' : '不可再次开具该发票'}内容`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                _invoiceContent.updateInvoiceState(rows.id, rows.state, () => {
                    this.$notify({
                        message: '修改成功',
                        type: 'success'
                    });
                })

            }).catch(() => {
                rows.state == 2 ? rows.state = 1 : rows.state = 2
                this.$message({
                    message: '已取消'
                });

            })






        }
    }
}
</script>

<style scoped>
.wapper {
    padding: 15px;
}

.header {
    margin-bottom: 15px;
}

.query-wapper {
    margin: 15px;
    padding: 15px;
    border: 1px solid #d6dbe5;
    position: relative;
    background: #fff;
}

.query-wapper::after {
    position: absolute;
    content: "筛选条件";
    top: -9px;
    color: #909399;
    background-color: #fbfbfb;
}

.content-wapper {
    padding: 0 15px;
    padding-bottom: 30px;
}

.button-wapper {
    margin-top: 10px;
}

.el-row {
    margin-bottom: 15px;
}
</style>